import AtlStorage from 'api/AtlStorage';

export const MACSwitchedUser = () => new AtlStorage(`mac.switched-user`, window.localStorage);
export const MACCreditCardDetails = () => new AtlStorage(`mac.cc-details`, window.sessionStorage);
